import { ICustomerPaymentMethod } from '../wrapper';

export class UserAccountInfo {
    public accountBalance: number;
    public paymentId: string;
    public paymentAmount?: number;
    public paymentStatus?: 'trialing' | 'active' | 'past_due' | 'canceled' | 'unpaid';
    public discountApplied?: number;
    public discountCodeApplied?: string;
    public discountEnd?: number;
    public delinquent?: boolean;
    public planDescription?: string;
    public contractStart?: number;
    public contractEnd?: number;
    public extendedContractInDays?: number;
    public cancelAt?: number;
    public defaultPaymentMethod?: ICustomerPaymentMethod;
    public planExpiresAt?: number;
}
